import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["list", "depth", "children", "disableHover", "noOptionsText", "disabled", "enableScrollIntoView"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef, useEffect } from 'react';
import Arrow from '@scaleflex/icons/arrow';
import PT from 'prop-types';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import Menu from '../menu';
import { Size } from './types';
import Styled from './menu-item.styles';
var MenuItem = intrinsicComponent(function (_ref, ref) {
  var list = _ref.list,
    _ref$depth = _ref.depth,
    depth = _ref$depth === void 0 ? 0 : _ref$depth,
    children = _ref.children,
    disableHover = _ref.disableHover,
    noOptionsText = _ref.noOptionsText,
    disabled = _ref.disabled,
    enableScrollIntoView = _ref.enableScrollIntoView,
    props = _objectWithoutProperties(_ref, _excluded);
  var menuItemRef = useRef(null);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    selectedIds = _React$useState4[0],
    setSelectedIds = _React$useState4[1];
  var handleOpenMenu = function handleOpenMenu(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleScroll = function handleScroll() {
    var _menuItemRef$current;
    (_menuItemRef$current = menuItemRef.current) === null || _menuItemRef$current === void 0 || _menuItemRef$current.scrollIntoView({
      behavior: 'auto',
      block: 'nearest'
    });
  };
  useEffect(function () {
    if (props.active && enableScrollIntoView) {
      handleScroll();
    }
  }, [props.active]);
  var handleSelectedId = function handleSelectedId(ev, selected, depthLevel) {
    var updatedArray = selectedIds.slice(0);
    updatedArray[depthLevel] = selected;
    setSelectedIds(updatedArray);
    handleOpenMenu(ev);
  };
  var handleCloseSubMenu = function handleCloseSubMenu(depthLevel) {
    var updatedArray = selectedIds.slice(0);
    updatedArray[depthLevel] = '';
    setSelectedIds(updatedArray);
    setAnchorEl(null);
  };
  var renderItems = function renderItems(options) {
    var depthLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return options.map(function (option) {
      var hasOptions = option.subList && option.subList.length > 0;
      var subMenu;
      if (selectedIds[depthLevel] === option.key && hasOptions) {
        var newDepthLevel = depthLevel + 1;
        subMenu = /*#__PURE__*/React.createElement(Menu, _extends({
          key: option.key,
          position: "right",
          open: Boolean(anchorEl),
          anchorEl: anchorEl,
          enableOverlay: false
        }, option.subMenuProps), /*#__PURE__*/React.createElement(MenuItem, _extends({
          list: option.subList,
          depth: newDepthLevel
        }, props)));
      }
      if (option.content === 'divider') {
        return /*#__PURE__*/React.createElement(Styled.MenuItemWrapper, {
          divider: true,
          key: option.key
        });
      }
      return /*#__PURE__*/React.createElement(Styled.MenuItemWrapper, _extends({
        disabled: false,
        key: option.key,
        onMouseLeave: function onMouseLeave() {
          return handleCloseSubMenu(depthLevel);
        }
      }, props), /*#__PURE__*/React.createElement(Styled.MenuItem, _extends({}, props, {
        className: option.className,
        ref: ref,
        active: Boolean(option.active),
        onClick: option.onClick ? function (event) {
          return option.onClick(_objectSpread({
            event: event
          }, props));
        } : undefined,
        onMouseEnter: function onMouseEnter(ev) {
          return handleSelectedId(ev, option.key, depthLevel);
        },
        disableHover: disableHover || option.disableHover
      }), option.prefix && /*#__PURE__*/React.createElement(Styled.MenuPrefix, null, typeof option.prefix === 'function' ? option.prefix(props) : option.prefix), option.content && /*#__PURE__*/React.createElement(Styled.MenuContent, null, typeof option.content === 'function' ? option.content(props) : option.content), (option.suffix || option.subList) && /*#__PURE__*/React.createElement(Styled.MenuSuffix, null, typeof option.suffix === 'function' ? option.suffix(props) : option.suffix, option.subList && /*#__PURE__*/React.createElement(Arrow, {
        size: 10,
        color: "#768A9F"
      }))), subMenu);
    });
  };
  if (!list) {
    if (props.value === 'divider') {
      return /*#__PURE__*/React.createElement(Styled.MenuItemWrapper, {
        divider: true,
        key: props.value
      });
    }
    return /*#__PURE__*/React.createElement(Styled.MenuItemWrapper, {
      noOptionsText: Boolean(noOptionsText),
      disabled: Boolean(disabled)
    }, /*#__PURE__*/React.createElement(Styled.MenuItem, _extends({}, props, {
      ref: menuItemRef,
      disableHover: disableHover,
      noOptionsText: noOptionsText,
      disabled: disabled
    }), children));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderItems(list, depth));
});
MenuItem.displayName = 'MenuItem';
export var defaultProps = {
  size: Size.Sm,
  active: false
};
MenuItem.defaultProps = defaultProps;
MenuItem.propTypes = {
  size: PT.oneOf(objectValues(Size)),
  children: PT.oneOfType([PT.node, PT.func]),
  active: PT.bool,
  value: PT.oneOfType([PT.string, PT.number, PT.bool, PT.oneOf([null])]),
  depth: PT.number,
  disableHover: PT.bool,
  noOptionsText: PT.bool,
  disabled: PT.bool,
  enableScrollIntoView: PT.bool
};
export default MenuItem;
// list: PT.arrayOf(
//   PT.shape({
//     key: PT.string.isRequired,
//     content: PT.oneOfType([PT.string, PT.node]).isRequired,
//     prefix: PT.oneOfType([PT.string, PT.node]),
//     subList: PT.arrayOf(PT.object),
//     suffix: PT.oneOfType([PT.string, PT.node]),
//     onClick: PT.func,
//     disabled: PT.bool,
//   })
// ),